import { dashboardMessages, useAppSelector, useDashboardPageLogic, UserState } from 'azshared';
import React, { useMemo } from 'react';
import { useIntl } from 'react-intl';
import { AppHeader } from '../../../components/header/header';
import { useGlobalActions } from '../../../hooks/global-actions';
import { HomeAzimutForYouCard } from './home-azimut-for-you-card/home-azimut-for-you-card';
import { HomeDocumentsCard } from './home-documents-card/home-documents-card';
import { HomeFinancialConsultantCard } from './home-financial-advisor-card/home-financial-consultant-card';
import { HomeMarketingAreaCard } from './home-marketing-area-card/home-marketing-area-card';
import { HomeNewsCard } from './home-news-card/home-news-card';
import { HomeSignatureAreaCard } from './home-signature-area-card/home-signature-area-card';
import { HomeWalletCard } from './home-wallet-card/home-wallet-card';
import { HomeToDoActivitiesCard } from './home-to-do-activities-card/home-to-do-activities-card';
import './home-page.scss';

export const HomePage = () => {
  const globalActions = useGlobalActions();
  const { formatMessage } = useIntl();
  const {
    practiceData,
    selectionDialogOpen,
    specimenUploadDialogOpen,
    onModalitySelected,
    openDialog,
    openSpecimenUploadDialog,
    handleSpecimenUploadSuccess,
    confirmSignDialogOpen,
    openConfirmSignDialog,
    closeConfirmSignDialog,
    onConfirmSign,
    mifidViewDialogOpen,
    openMifidViewDialog,
    closeMifidViewDialog,
    onMifidView,
    onMifidModify,
    documents,
    signature,
    news,
    financialAdvisor,
    video,
    sections,
    selectedSection,
    onSelectedSection,
    myWallet,
    setFlagShowBalance,
    sharedAccounts,
    dossierRequestStatus,
    toDoActivities,
    startWebCollaborationDialogOpen,
    startWebCollaboration,
    onCloseStartWebCollaborationDialog
  } = useDashboardPageLogic(globalActions);

  const { informativeMode, isProspect, fiduciaria } = useAppSelector<UserState>((state) => state.data.user);
  const isSelectedPirBox = selectedSection === 'PIR_BOX';

  const showSignatureAreaCard = useMemo(() => {
    const showSign = practiceData?.value?.processStateCode >= 2;
    return !informativeMode && !fiduciaria && !(isProspect && !showSign);
  }, [informativeMode, fiduciaria, isProspect, practiceData]);

  return (
    <div className='home-page'>
      <AppHeader />
      {isProspect ? <h2>{formatMessage(dashboardMessages.title)}</h2> : <h2>{formatMessage(dashboardMessages.walletCardTitle)}</h2>}
      <div className={`home-page-content ${isSelectedPirBox && 'pir-box'}`}>
        <div className='home-page-wallet-section'>
          {/* Wallet section */}
          {isProspect && (
            <HomeToDoActivitiesCard
              practiceData={practiceData}
              toDoActivities={toDoActivities}
              handleSelectionDialog={openDialog}
              handleSpecimenUploadDialog={openSpecimenUploadDialog}
              handleSpecimenUploadSuccess={handleSpecimenUploadSuccess}
              onModalitySelected={onModalitySelected}
              openSelectionDialog={selectionDialogOpen}
              openSpecimenUploadDialog={specimenUploadDialogOpen}
              startWebCollaborationDialogOpen={startWebCollaborationDialogOpen}
              startWebCollaboration={startWebCollaboration}
              onCloseStartWebCollaborationDialog={onCloseStartWebCollaborationDialog}
              confirmSignDialogOpen={confirmSignDialogOpen}
              openConfirmSignDialog={openConfirmSignDialog}
              closeConfirmSignDialog={closeConfirmSignDialog}
              onConfirmSign={onConfirmSign}
              mifidViewDialogOpen={mifidViewDialogOpen}
              openMifidViewDialog={openMifidViewDialog}
              closeMifidViewDialog={closeMifidViewDialog}
              onMifidView={onMifidView}
              onMifidModify={onMifidModify}
            />
          )}
          {isProspect && <HomeMarketingAreaCard />}
          {!isProspect && (
            <HomeWalletCard
              dossierRequestStatus={dossierRequestStatus}
              myWalletHomeCard={myWallet}
              sharedAccounts={sharedAccounts}
              sections={sections}
              selectedSection={selectedSection}
              onSelectedSection={onSelectedSection}
              setFlagShowBalance={setFlagShowBalance}
            />
          )}
        </div>
        {selectedSection !== 'PIR_BOX' && (
          <>
            <div className='home-page-second-column'>
              {/* card: signature, azimut and news */}
              {/* card: document, financial consultant, azimut for you */}
              {showSignatureAreaCard && <HomeSignatureAreaCard documents={signature} />}
              {!isProspect && <HomeDocumentsCard totalDocuments={documents} />}
              <HomeFinancialConsultantCard isProspect={isProspect} consultant={financialAdvisor} />
              {!informativeMode && <HomeNewsCard news={news} />}
              {!isProspect && <HomeMarketingAreaCard />}
              {video && !informativeMode && <HomeAzimutForYouCard video={video} />}
            </div>
          </>
        )}
      </div>
    </div>
  );
};
